export default "__VITE_ASSET__DoUNmIwL__"